/**
 * Version for the external store
 * It's used to know if we need to invalidate the store or not
 *
 * This needs to be incremented in case we have change related to the state structure that we judge
 * would be a breaking change in terms of data structure or worse for UX
 */
export const version = 1
